import { render, staticRenderFns } from "./MemberDetail/template.html?vue&type=template&id=5374c020&scoped=true&"
import script from "./MemberDetail/script.ts?vue&type=script&lang=js&"
export * from "./MemberDetail/script.ts?vue&type=script&lang=js&"
import style0 from "./MemberDetail/style.scss?vue&type=style&index=0&id=5374c020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5374c020",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VDataTable,VDivider,VImg})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
